import { Injectable } from '@angular/core';
import { BehaviorTrackerService } from 'app/behavior-tracking/behavior-tracker.service';
import dayjs from 'dayjs';
import { filter, Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { AppState } from './app.state';
import { UserRouteService } from './core/services/user-routes/user-routes.service';
import { IAppState } from './shared/models/app-state.interface';
import { UserService } from './shared/services/user/user.service';

@Injectable({ providedIn: 'root' })
export class AppStateService {
    public constructor(private readonly appState: AppState,
                       private readonly userService: UserService,
                       private readonly userRouteService: UserRouteService,
                       private readonly behaviorTracker: BehaviorTrackerService,
    ) {
    }

    public refreshAppState(): Observable<IAppState> {
        return this.userService.getUser()
                   .pipe(
                       filter(user => !!user),
                       switchMap(user => this.userService.getCustomer()
                                             .pipe(map((customer) => ({ user, customer })))),
                       tap((res) => {
                           const user = res?.user;
                           const customer = res?.customer;

                           this.appState.user$.set(user);
                           this.appState.customer$.set(customer);

                           if (user) {
                               this.behaviorTracker.identify(
                                   user.UserId.toString(),
                                   {
                                       customerId: user.CustomerId,
                                       name: `${ user.FirstName } ${ user.LastName }`,
                                       email: user.Email,
                                       country: user.CountryCode,
                                   });
                           }
                       }),
                       map((res) => {
                           const user = res?.user;
                           const customer = res?.customer;
                           const userRoutes = this.userRouteService.loadUserRoutes(res?.user, res?.customer);
                           this.appState.userRoutes$.set(userRoutes);
                           this.appState.lastRetrievalDate = dayjs().toDate();

                           return {
                               user,
                               customer,
                               userRoutes,
                           };
                       }),
                   );
    }
}
